/**
 * LegendCategory Component
 * Renders a category header with its list of items
 */

import type { LegendCategory as LegendCategoryType } from './useLegendData';
import { LegendItem } from './LegendItem';

interface LegendCategoryProps {
  category: LegendCategoryType;
  isFirst?: boolean;
  scale?: number;
}

// Base sizes that will be scaled
const BASE_SIZES = {
  marginTop: 10,
  headerFontSize: 10,
  headerMarginBottom: 6,
  headerLetterSpacing: 0.5,
  headerPaddingBottom: 4,
  itemsGap: 2,
};

export function LegendCategory({ category, isFirst = false, scale = 1 }: LegendCategoryProps) {
  // Calculate scaled sizes
  const marginTop = BASE_SIZES.marginTop * scale;
  const headerFontSize = BASE_SIZES.headerFontSize * scale;
  const headerMarginBottom = BASE_SIZES.headerMarginBottom * scale;
  const headerLetterSpacing = BASE_SIZES.headerLetterSpacing * scale;
  const headerPaddingBottom = BASE_SIZES.headerPaddingBottom * scale;
  const itemsGap = BASE_SIZES.itemsGap * scale;

  const styles = {
    container: {
      marginTop: `${marginTop}px`,
    } as React.CSSProperties,
    containerFirst: {
      marginTop: '0',
    } as React.CSSProperties,
    header: {
      fontSize: `${headerFontSize}px`,
      fontWeight: 600,
      color: '#000000',
      marginBottom: `${headerMarginBottom}px`,
      textTransform: 'uppercase' as const,
      letterSpacing: `${headerLetterSpacing}px`,
      borderBottom: '1px solid #e5e5e5',
      paddingBottom: `${headerPaddingBottom}px`,
    } as React.CSSProperties,
    itemsList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: `${itemsGap}px`,
    } as React.CSSProperties,
  };

  return (
    <div style={isFirst ? styles.containerFirst : styles.container}>
      <div style={styles.header}>{category.name}</div>
      <div style={styles.itemsList}>
        {category.items.map(item => (
          <LegendItem key={item.key} item={item} scale={scale} />
        ))}
      </div>
    </div>
  );
}
